export default __webpack_public_path__ + "static/media/agentQueryLog.e87b9587.less";